// /src/renderer/analysis/rendering/Panels/renderers/DICOMPanel.tsx
import React from 'react';
import '../PanelContainer.scss';
import PanelOverlay from './PanelOverlay';
import { PanelCommonProps, PanelOverlayConfig } from 'config/panelConfig';


const EmptyPanel: React.FC<PanelCommonProps> = ({
  className
}: PanelCommonProps) => {
  // 패널 내 오버레이에 필요한 상태나 계산 로직이 있을 수 있음
  // panelConfig.componentKey
  return (
    <div className={`panel ${className}`}>

    </div>
  );
};

export default EmptyPanel;
